export const blogActionTypes = {
    
    /**
     * Blog fetch action types
     */
    GET_BLOG_ARTICLES_REQUEST: 'BLOG_GET_BLOG_ARTICLES_REQUEST',
    GET_BLOG_ARTICLES_SUCCESS: 'BLOG_GET_BLOG_ARTICLES_SUCCESS',
    GET_BLOG_ARTICLES_FAILURE: 'BLOG_GET_BLOG_ARTICLES_FAILURE',
    
};